module.exports = __webpack_public_path__ + "img/imgs3.0494b9a6.png";